// @ts-nocheck
import becomeADistributorFormReducer, {
    BunzlComponentsBecomeADistributorFormActions,
} from "@store/Framework/Store/Bunzl/Components/BecomeADistributorForm/BecomeADistributorFormReducer";
import requestAQuoteFormReducer, {
    BunzlComponentsRequestAQuoteFormActions,
} from "@store/Framework/Store/Bunzl/Components/RequestAQuoteForm/RequestAQuoteFormReducer";
import headerReducer, {
    BunzlComponentsHeaderActions,
} from "@store/Framework/Store/Bunzl/Components/Header/HeaderReducer";
import { BunzlComponentsOrderDetailsTotalActions } from "@store/Framework/Store/Bunzl/Components/OrderDetailsTotal/OrderDetailsTotalReducer";
import orderDetailsTotalReducer from "@store/Framework/Store/Bunzl/Components/OrderDetailsTotal/OrderDetailsTotalReducer";

import { combineReducers } from "redux";

const componentsReducers = {
    header: headerReducer,
    orderDetailsTotal: orderDetailsTotalReducer,
    requestAQuote: requestAQuoteFormReducer,
    becomeADistributor: becomeADistributorFormReducer,
};

export type BunzlComponentsActions =
    | BunzlComponentsOrderDetailsTotalActions
    | BunzlComponentsHeaderActions
    | BunzlComponentsRequestAQuoteFormActions
    | BunzlComponentsBecomeADistributorFormActions;
export default combineReducers(componentsReducers);
